module.exports = __webpack_public_path__ + "static/img/preview-05.f383b341.webp";